import Button from "../Button";
import Modal from "../Modal";

interface ConfirmDialogProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void | Promise<void>;
  title: string;
  description: string;
  confirmText?: string;
  cancelText?: string;
  isLoading?: boolean;
  variant?: "danger" | "primary";
}

export default function ConfirmDialog({
  isOpen,
  onClose,
  onConfirm,
  title,
  description,
  confirmText = "Confirmer",
  cancelText = "Annuler",
  isLoading = false,
  variant = "danger",
}: ConfirmDialogProps) {
  const handleConfirm = async () => {
    await onConfirm();
  };

  return (
    <Modal
      isModalOpen={isOpen}
      onClose={onClose}
      title={title}
      description={description}
      className="w-xl"
      dialogClassName="z-[400]"
    >
      <div className="flex justify-end gap-2 pt-4">
        <Button
          variant="secondary"
          onClick={onClose}
          disabled={isLoading}
          dataTestId="confirm-dialog-cancel"
        >
          {cancelText}
        </Button>
        <Button
          variant={variant}
          onClick={handleConfirm}
          isLoading={isLoading}
          disabled={isLoading}
          dataTestId="confirm-dialog-accept"
        >
          {confirmText}
        </Button>
      </div>
    </Modal>
  );
}
